// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1ty3l","subheader":"ReorderModal_subheader__j6Upd","listWrap":"ReorderModal_listWrap__v2W9n"};